function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.298584 19C0.298584 16.7909 2.08945 15 4.29858 15H30.2986V145H4.29858C2.08944 145 0.298584 143.209 0.298584 141V19Z",
  fill: "url(#paint0_linear_1058_3282)"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0.298584 19C0.298584 16.7909 2.08945 15 4.29858 15H30.2986V145H4.29858C2.08944 145 0.298584 143.209 0.298584 141V19Z",
  fill: "black",
  fillOpacity: 0.75
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M30.2986 9C30.2986 6.79086 32.0894 5 34.2986 5H70.2986V155H34.2986C32.0894 155 30.2986 153.209 30.2986 151V9Z",
  fill: "url(#paint1_linear_1058_3282)"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M30.2986 9C30.2986 6.79086 32.0894 5 34.2986 5H70.2986V155H34.2986C32.0894 155 30.2986 153.209 30.2986 151V9Z",
  fill: "black",
  fillOpacity: 0.5
});
var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 70.2986,
  width: 119.403,
  height: 160,
  rx: 4,
  fill: "url(#paint2_linear_1058_3282)"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M128.333 100H113.333V80H128.333V100ZM128.333 70H110V76.6667H128.333V70ZM131.667 100H146.667V80H131.667V100ZM131.667 70V76.6667H150V70H131.667ZM138.948 60C134.037 60 131.163 65.795 130 68.3333H138.908C144.73 68.3333 144.792 60 138.948 60ZM137.622 66.035H134.217C135.448 64.1667 136.615 62.7583 138.12 62.7583C140.073 62.7583 140.167 66.035 137.622 66.035ZM121.092 68.3333H130C128.837 65.795 125.963 60 121.052 60C115.208 60 115.27 68.3333 121.092 68.3333ZM121.88 62.7583C123.385 62.7583 124.552 64.1667 125.783 66.035H122.378C119.833 66.035 119.927 62.7583 121.88 62.7583Z",
  fill: "#065F46"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M189.701 5H225.701C227.911 5 229.701 6.79086 229.701 9V151C229.701 153.209 227.911 155 225.701 155H189.701V5Z",
  fill: "url(#paint3_linear_1058_3282)"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M189.701 5H225.701C227.911 5 229.701 6.79086 229.701 9V151C229.701 153.209 227.911 155 225.701 155H189.701V5Z",
  fill: "black",
  fillOpacity: 0.5
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M229.701 15H255.701C257.911 15 259.701 16.7909 259.701 19V141C259.701 143.209 257.911 145 255.701 145H229.701V15Z",
  fill: "url(#paint4_linear_1058_3282)"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M229.701 15H255.701C257.911 15 259.701 16.7909 259.701 19V141C259.701 143.209 257.911 145 255.701 145H229.701V15Z",
  fill: "black",
  fillOpacity: 0.75
});
var _ref12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1058_3282",
  x1: 0.298584,
  y1: 15,
  x2: 25.7433,
  y2: 24.5387,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6EE7B7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_1058_3282",
  x1: 30.2986,
  y1: 5,
  x2: 62.8788,
  y2: 19.1135,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6EE7B7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_1058_3282",
  x1: 70.2986,
  y1: 0,
  x2: 117.068,
  y2: 56.6985,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6EE7B7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_1058_3282",
  x1: 189.701,
  y1: 5,
  x2: 222.282,
  y2: 19.1135,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6EE7B7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_1058_3282",
  x1: 229.701,
  y1: 15,
  x2: 255.146,
  y2: 24.5387,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6EE7B7"
})));
function SvgConnectWalletImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 160,
    viewBox: "0 0 260 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectWalletImage);
export default __webpack_public_path__ + "static/media/connectWalletImage.dd117088eb2a063f11cea7e920fd2886.svg";
export { ForwardRef as ReactComponent };